import React, { Component } from 'react';
import { Row, Col, Menu, Collapse } from 'antd';
import Support from '../Support';
import { Helmet } from "react-helmet";

import './QA.css';

var cashbackDesc =
    'Earning cashback on the QbatesApp is easy. You just need to start your shopping trip on the \n' +
    'Qbates website or mobile app. Our cutting-edge technology will do the rest.\n' +
    'Once your order was placed, normally you will be able to see the transaction hisotry within 24 hours.';
var paymentDesc =
    'Once your cash back is available, you can make a cash back request inside the app. The payment will be executed' +
    ' on the 7th of each month, and you should be able to receive the payment within 24 hours. If not, please' +
    ' contact us via ';
var paymentDesc1 =
    'Please notes, in order to keep the service functional and serve you better, we will deduct $1 as a ' +
    'membership fee if and only if your rewards equal more than $10 for the give month. For any given month ' +
    'less than $10, it is completely free.';




class QA extends Component {

  state = {
    current: 'How to Earn Cash Back?',
  };


  handleClick = (e) => {
    this.setState({
      current: e.key,
    });
  };

  render() {
    return (
      <div className="QA">
        <Helmet>
          <title>Support - Qbates</title>
          <meta name="description" content="Support, Questions and Answers" />
        </Helmet>
        <Support/>
        <div className="Collapse">
          <h2>Question</h2>
          <Collapse accordion defaultActiveKey={['How to Earn Cash Back?']}>
              <Collapse.Panel header={'How to Earn Cash Back?'} key="How to Earn Cash Back?">
                  <p>{cashbackDesc}</p>
              </Collapse.Panel>

              <Collapse.Panel header={'Payment Policy'} key="Payment Policy">
                  <p>{paymentDesc} <b> hello@qbatesapp.com </b> </p>
                  <p>{paymentDesc1}</p>
              </Collapse.Panel>
            {/*<Collapse.Panel header={'User guideline'} key="User guideline">*/}
            {/*<Collapse.Panel header={'Qbates service policy'} key="Qbates service policy">*/}
              {/*<p>.<br/><br/>*/}
                {/*.</p>*/}
            {/*</Collapse.Panel>*/}
            {/*<Collapse.Panel header={'Terms of use'} key="Terms of use">*/}
              {/*<p> Subway.<br/><br/>*/}
                {/*Qbates.</p>*/}
            {/*</Collapse.Panel>*/}
          </Collapse>
        </div>

        <Row className="QA-inner">
          <Col span={7}>
            <Menu onClick={this.handleClick}
              selectedKeys={[this.state.current]}>
                <Menu.Item key="How to Earn Cash Back?">
                    How to Earn Cash Back?
                </Menu.Item>
                <Menu.Item key="Payment Policy">
                  Payment Policy
                </Menu.Item>
              {/*<Menu.Item*/}
                {/*key="User guideline"*/}
              {/*>*/}
                {/*User guideline*/}
              {/*</Menu.Item>*/}
              {/*<Menu.Item*/}
                {/*key="Qbates service policy"*/}
              {/*>*/}
                {/*Qbates service policy*/}
              {/*</Menu.Item>*/}
              {/*<Menu.Item*/}
                {/*key="Terms of use"*/}
              {/*>*/}
                {/*Terms of use*/}
              {/*</Menu.Item>*/}
            </Menu>
          </Col>
          <Col span={17}>
              <div style={{ display: this.state.current === 'How to Earn Cash Back?' ? 'block' : 'none' }}>
                  <h2>How to Earn Cash Back?</h2>
                  <p>{cashbackDesc}</p>
              </div>
              <div style={{ display: this.state.current === 'Payment Policy' ? 'block' : 'none' }}>
                  <h2>Payment Policy</h2>
                  <p>{paymentDesc} <b> hello@qbatesapp.com </b> </p>
                  <p>{paymentDesc1}</p>
              </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default QA;


// WEBPACK FOOTER //
// ./src/Containers/Support/components/QA.js